import {InjectionToken} from "@angular/core";


export const N_THEME = new InjectionToken("theme");

export interface INControlsTheme {
  baseColor: string;
}

export const DEFAULT_THEME: INControlsTheme = {
  baseColor: "#008aff"
};
